export const MINI_VARIANT_DRAWER_WIDTH = '5rem';
export const TEMPORARY_DRAWER_WIDTH = '20rem';
export const DRAWER_DEFAULT_Z_INDEX = 1200;
